export default __webpack_public_path__ + "static/media/assets-foiling_00.7d9451ca.jpg";